module.exports = __webpack_public_path__ + "static/media/test-overview.f2de1271.svg";